"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  TagsCheck: ['tags-check', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,19.188a1.5,1.5,0,0,1-2.121,0L1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06', 'M16.189,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M10.939 17.249 A6.000 6.000 0 1 0 22.939 17.249 A6.000 6.000 0 1 0 10.939 17.249 Z', 'M19.613,15.5l-2.905,3.874a.75.75,0,0,1-1.13.08l-1.5-1.5']],
  TagsCash: ['tags-cash', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,19.188a1.5,1.5,0,0,1-2.121,0L1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06', 'M16.189,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M18.439,14.249H16.406a1.341,1.341,0,0,0-.5,2.587l2.063.826a1.342,1.342,0,0,1-.5,2.587H15.439', 'M16.939 14.249L16.939 13.499', 'M16.939 20.999L16.939 20.249', 'M10.939 17.249 A6.000 6.000 0 1 0 22.939 17.249 A6.000 6.000 0 1 0 10.939 17.249 Z']],
  TagsLock: ['tags-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.75,19.188a1.5,1.5,0,0,1-2.121,0L2.25,13.81a1.5,1.5,0,0,1,0-2.122l10.5-10.5A1.5,1.5,0,0,1,13.811.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06', 'M17.314,4.5a.375.375,0,0,0-.375-.375h0a.375.375,0,1,0,.375.375', 'M13.189 15.749 L22.189 15.749 L22.189 23.249 L13.189 23.249 Z', 'M17.689,11.249h0a3,3,0,0,0-3,3v1.5h6v-1.5A3,3,0,0,0,17.689,11.249Z', 'M17.689,19.153a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0']],
  TagsDouble1: ['tags-double-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5 1.353L12 1.353 22.5 11.853', 'M9.129,4.353H3a1.5,1.5,0,0,0-1.5,1.5v6.128a1.5,1.5,0,0,0,.439,1.061L11.1,22.205a1.5,1.5,0,0,0,2.465-.534L15,17.853l3.819-1.433a1.5,1.5,0,0,0,.534-2.465L10.189,4.792A1.5,1.5,0,0,0,9.129,4.353Z', 'M6 8.478L6 8.478', 'M6,8.478a.375.375,0,1,0,.375.375A.374.374,0,0,0,6,8.478']],
  Tags: ['tags', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.061,2.56V8.817a3,3,0,0,0,.878,2.121L13.5,22.5a1.5,1.5,0,0,0,2.121,0L22.5,15.62a1.5,1.5,0,0,0,0-2.121L10.939,1.938A3,3,0,0,0,8.818,1.06H2.561A1.5,1.5,0,0,0,1.061,2.56Z', 'M4.811 6.310 A1.500 1.500 0 1 0 7.811 6.310 A1.500 1.500 0 1 0 4.811 6.310 Z']],
  Bookmarks2: ['bookmarks-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.5,4.05A1.5,1.5,0,0,0,15,5.55V22.2a.75.75,0,0,1-1.147.636L9,19.8,4.147,22.833A.75.75,0,0,1,3,22.2V5.55a4.5,4.5,0,0,1,4.5-4.5h9A4.5,4.5,0,0,1,21,5.55V9.3a.75.75,0,0,1-.75.75l-5.25,0']],
  Bookmarks: ['bookmarks', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.32,22.767,12,18.343,5.68,22.767a.75.75,0,0,1-1.18-.614V2.593A1.5,1.5,0,0,1,6,1.093H18a1.5,1.5,0,0,1,1.5,1.5v19.56A.75.75,0,0,1,18.32,22.767Z', 'M9 1.094L9 20.443', 'M15 1.094L15 20.443']],
  Tags1: ['tags-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.135,2.634V8.892a3,3,0,0,0,.879,2.121l11.63,11.63a.75.75,0,0,0,1.266-.383l1.225-6.126,6.126-1.225a.75.75,0,0,0,.383-1.266L11.014,2.013a3,3,0,0,0-2.121-.879H2.635A1.5,1.5,0,0,0,1.135,2.634Z', 'M4.885 6.384 A1.500 1.500 0 1 0 7.885 6.384 A1.500 1.500 0 1 0 4.885 6.384 Z']],
  BookmarksDocument: ['bookmarks-document', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.25,2.249h-3a1.5,1.5,0,0,0-1.5,1.5v18a1.5,1.5,0,0,0,1.5,1.5h19.5a1.5,1.5,0,0,0,1.5-1.5v-18a1.5,1.5,0,0,0-1.5-1.5H11.25', 'M11.25,11.249,8.25,9l-3,2.25V1.5A.75.75,0,0,1,6,.749h4.5a.75.75,0,0,1,.75.75Z', 'M5.25 18.749L15.75 18.749', 'M5.25 14.249L18.75 14.249', 'M18.75 9.749L14.25 9.749']],
  TagsDouble: ['tags-double', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5,1.06h6.879a1.5,1.5,0,0,1,1.06.439L22.5,11.56', 'M9.129,4.06H3a1.5,1.5,0,0,0-1.5,1.5v6.128a1.5,1.5,0,0,0,.439,1.061l9.75,9.75a1.5,1.5,0,0,0,2.122,0l6.128-6.129a1.5,1.5,0,0,0,0-2.121L10.189,4.5A1.5,1.5,0,0,0,9.129,4.06Z', 'M6,8.185a.375.375,0,1,0,.375.375A.374.374,0,0,0,6,8.185H6']],
  TagsEdit: ['tags-edit', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.879,19.188,1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628', 'M16.189 4.124L16.189 4.124', 'M16.189,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M22.32,14.868,14.689,22.5l-3.75.75.75-3.75,7.631-7.631a2.115,2.115,0,0,1,2.991,0l.009.009A2.115,2.115,0,0,1,22.32,14.868Z']],
  TagsSearch: ['tags-search', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.064,19.188a1.5,1.5,0,0,1-2.121,0L1.564,13.81a1.5,1.5,0,0,1,0-2.122l10.5-10.5A1.5,1.5,0,0,1,13.125.749H18.5a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.44,1.06', 'M16.254,4.124a.375.375,0,1,0,.375.375.374.374,0,0,0-.375-.375h0', 'M10.875 16.499 A5.250 5.250 0 1 0 21.375 16.499 A5.250 5.250 0 1 0 10.875 16.499 Z', 'M22.875 23.249L19.861 20.235']],
  TagsShare: ['tags-share', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,19.188a1.5,1.5,0,0,1-2.121,0L1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06', 'M16.189,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M10.939 17.999 A2.250 2.250 0 1 0 15.439 17.999 A2.250 2.250 0 1 0 10.939 17.999 Z', 'M18.439 20.999 A2.250 2.250 0 1 0 22.939 20.999 A2.250 2.250 0 1 0 18.439 20.999 Z', 'M18.439 13.499 A2.250 2.250 0 1 0 22.939 13.499 A2.250 2.250 0 1 0 18.439 13.499 Z', 'M15.114 16.844L18.764 14.654', 'M15.277 18.834L18.602 20.164']],
  TagsRemove: ['tags-remove', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,19.188a1.5,1.5,0,0,1-2.121,0L1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06', 'M16.189,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M10.939 17.249 A6.000 6.000 0 1 0 22.939 17.249 A6.000 6.000 0 1 0 10.939 17.249 Z', 'M19.189 14.998L14.689 19.498', 'M14.689 14.998L19.189 19.498']],
  Bookmarks1: ['bookmarks-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.6,2.032,21.967,8.4a1.5,1.5,0,0,1,0,2.121L10.3,22.184a.75.75,0,0,1-1.281-.53l-.31-6.364-6.364-.311a.75.75,0,0,1-.53-1.28L13.482,2.032A1.5,1.5,0,0,1,15.6,2.032Z']],
  TagsDownload: ['tags-download', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,19.188a1.5,1.5,0,0,1-2.121,0L1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06', 'M16.189,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M10.939 17.249 A6.000 6.000 0 1 0 22.939 17.249 A6.000 6.000 0 1 0 10.939 17.249 Z', 'M16.939 14.249L16.939 20.249', 'M16.939 20.249L14.689 17.999', 'M16.939 20.249L19.189 17.999']],
  TagsRefresh: ['tags-refresh', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.879,19.188,1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06', 'M16.189,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M14.689 18.749L10.939 18.749 10.939 22.499', 'M22.357,19.482a5.572,5.572,0,0,1-10.74-.733', 'M19.189 15.749L22.939 15.749 22.939 11.999', 'M11.522,15.015a5.573,5.573,0,0,1,10.74.734']],
  TagsSettings: ['tags-settings', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.879,19.188,1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628', 'M16.564,4.5a.375.375,0,0,0-.375-.375h0a.375.375,0,1,0,.375.375', 'M15.439 16.499 A1.500 1.500 0 1 0 18.439 16.499 A1.500 1.500 0 1 0 15.439 16.499 Z', 'M18.214,10.7l.442,1.453a.994.994,0,0,0,1.173.681l1.473-.342a1.339,1.339,0,0,1,1.274,2.219l-1.03,1.111a1,1,0,0,0,0,1.362l1.03,1.111A1.339,1.339,0,0,1,21.3,20.509l-1.473-.341a.992.992,0,0,0-1.173.681L18.214,22.3a1.331,1.331,0,0,1-2.549,0l-.442-1.452a.993.993,0,0,0-1.174-.681l-1.472.341A1.338,1.338,0,0,1,11.3,18.291l1.03-1.111a1,1,0,0,0,0-1.362L11.3,14.707a1.339,1.339,0,0,1,1.274-2.219l1.472.342a1,1,0,0,0,1.174-.681l.442-1.453A1.331,1.331,0,0,1,18.214,10.7Z']],
  TagsUpload: ['tags-upload', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.125,4.124A.375.375,0,1,0,16.5,4.5a.375.375,0,0,0-.375-.375h0', 'M9,19.188a1.5,1.5,0,0,1-2.121,0L1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06', 'M10.939 17.249 A6.000 6.000 0 1 0 22.939 17.249 A6.000 6.000 0 1 0 10.939 17.249 Z', 'M16.939 20.249L16.939 14.249', 'M16.939 14.249L14.689 16.499', 'M16.939 14.249L19.189 16.499']],
  TagsMinus: ['tags-minus', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,19.188a1.5,1.5,0,0,1-2.121,0L1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06', 'M16.189 4.124L16.189 4.124', 'M16.189,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M10.939 17.249 A6.000 6.000 0 1 0 22.939 17.249 A6.000 6.000 0 1 0 10.939 17.249 Z', 'M14.689 17.249L19.189 17.249']],
  TagsFavoriteStar: ['tags-favorite-star', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.012,19.188a1.5,1.5,0,0,1-2.121,0L1.512,13.81a1.5,1.5,0,0,1,0-2.122l10.5-10.5A1.5,1.5,0,0,1,13.073.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06', 'M16.2,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M17.624,11.679l1.541,4.07h3a.735.735,0,0,1,.519,1.283l-2.6,1.815,1.443,3.314a.786.786,0,0,1-1.119.982l-3.487-1.961L13.43,23.143a.786.786,0,0,1-1.119-.982l1.443-3.314-2.6-1.815a.734.734,0,0,1,.515-1.283h3l1.545-4.07A.8.8,0,0,1,17.624,11.679Z']],
  TagsAdd: ['tags-add', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,19.188a1.5,1.5,0,0,1-2.121,0L1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06', 'M16.189 4.124L16.189 4.124', 'M16.189,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M10.939 17.249 A6.000 6.000 0 1 0 22.939 17.249 A6.000 6.000 0 1 0 10.939 17.249 Z', 'M16.939 14.999L16.939 19.499', 'M14.689 17.249L19.189 17.249']],
  TagsBlock: ['tags-block', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,19.188a1.5,1.5,0,0,1-2.121,0L1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06', 'M16.189,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M10.939 17.249 A6.000 6.000 0 1 0 22.939 17.249 A6.000 6.000 0 1 0 10.939 17.249 Z', 'M21.182 13.006L12.698 21.491']],
  TagsAlert: ['tags-alert', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,19.188a1.5,1.5,0,0,1-2.121,0L1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06', 'M16.189 4.124L16.189 4.124', 'M16.189,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M16.939 20.249L16.939 20.249', 'M16.939,20.249a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M16.939 17.999L16.939 14.999', 'M22.752,20.681a1.774,1.774,0,0,1-1.587,2.568H12.713a1.773,1.773,0,0,1-1.586-2.568l4.225-8.451a1.774,1.774,0,0,1,3.174,0Z']],
  TagsFavorite: ['tags-favorite', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,19.3a1.5,1.5,0,0,1-2.121,0L1.5,13.92a1.5,1.5,0,0,1,0-2.121L12,1.3A1.5,1.5,0,0,1,13.061.86h5.378a1.5,1.5,0,0,1,1.5,1.5V7.738A1.5,1.5,0,0,1,19.5,8.8', 'M16.189,4.235a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M16.939,23.138,11.826,17.8a3.025,3.025,0,0,1-.567-3.492h0a3.025,3.025,0,0,1,4.845-.786l.835.835.836-.835a3.025,3.025,0,0,1,4.845.786h0a3.025,3.025,0,0,1-.567,3.492Z']]
};
exports["default"] = _default;